module.exports = __webpack_public_path__ + "static/media/poppins-medium-webfont.bc0b5762.ttf";